export const dictionary = {
  'get-check-address-messages': 'check-address-messages-received',
  'update-check-address-messages': 'check-address-text-updated',
  'get-product-types': 'product-types-received',
  'update-product-types': 'product-types-updated'
}
